import {getRequestById} from "../../actions/requestActions";

export function RequestModel2017({ request, setActiveForm, match })
{
    const requestMe = request.mySide === "RECIPIENT";
    const onMySide =
        request.pendingSide === request.mySide || request.mySide === "BOTH";

    let headerTitle = '';
    let debugChosenCase = -1;

    if( request.status === "INITIAL" )
    {
        if( request.pendingSide === "RECIPIENT" )
        {
            if( onMySide )
            {
                headerTitle = "POŽADAVEK ČEKAJÍCÍ NA VAŠE PŘIJETÍ";
            }
            else
            {
                headerTitle = "POŽADAVEK ČEKAJÍCÍ NA PŘIJETÍ";
            }
        }
        else
        {
            if( onMySide )
            {
                headerTitle = "POŽADAVEK ČEKAJÍCÍ NA PŘIJETÍ";
            }
            else
            {
                headerTitle = "POŽADAVEK ČEKAJÍCÍ NA VAŠE PŘIJETÍ";
            }
        }
    }
    else if( request.status === "ACCEPTED" )
    {
        if( request.pendingSide === "RECIPIENT" )
        {
            if( onMySide )
            {
                headerTitle = "POŽADAVEK ČEKAJÍCÍ NA VAŠE ŘEŠENÍ";
            }
            else
            {
                headerTitle = "POŽADAVEK ČEKAJÍCÍ NA ŘEŠENÍ";
            }
        }
        else
        {
            if( onMySide )
            {
                headerTitle = "POŽADAVEK ČEKAJÍCÍ NA ŘEŠENÍ";
            }
            else
            {
                headerTitle = "POŽADAVEK ČEKAJÍCÍ NA VAŠE ŘEŠENÍ";
            }
        }
    }
    else if( request.status === "RESOLVING" )
    {
        if( request.pendingSide === "RECIPIENT" )
        {
            if( onMySide )
            {
                headerTitle = "ČEKÁ SE NA POTVRZENÍ VYŘEŠENÍ";
            }
            else
            {
                headerTitle = "ČEKÁ SE NA POTVRZENÍ VYŘEŠENÍ";
            }
        }
        else
        {
            if( onMySide )
            {
                headerTitle = "ČEKÁ SE NA POTVRZENÍ VYŘEŠENÍ";
            }
            else
            {
                headerTitle = "ČEKÁ SE NA POTVRZENÍ VYŘEŠENÍ";
            }
        }
    }
    else if( request.status === "RESOLVED" )
    {
        headerTitle = "POŽADAVEK JE VYŘEŠENÝ";
    }
    else if( request.status === "DISMISSED" )
    {
        headerTitle = "POŽADAVEK NEMOHL BÝT VYŘEŠENÝ";
    }
    else if( request.status === "CLOSED" )
    {
        if( request.pendingSide === "RECIPIENT" )
        {
            headerTitle = "POŽADAVEK UZAVŘEN ŘEŠITELEM";
        }
        else
        {
            headerTitle = "POŽADAVEK UZAVŘEN";
        }
    }
    else
    {
        headerTitle = "";
    }

    let buttons = null;

    if( request.status === "INITIAL" )
    {
        if( request.pendingSide === "RECIPIENT" )
        {
            if( onMySide )
            {
                if( request.type === "INVITE_PROVIDER" )
                {
                    buttons = [
                        {
                            label: "Odmítnout",
                            onClick: () =>
                                setActiveForm( "requestContentForm", {
                                    formData: {status: "CLOSED"},
                                    primaryButtonLabel: "Odmítnout"
                                } )
                        },
                        {
                            label: "Navrhnout další",
                            onClick: () =>
                                setActiveForm( "requestContentForm", {
                                    formData: {},
                                    primaryButtonLabel: "Navrhnout další"
                                } )
                        }
                    ];
                }
                else
                {
                    buttons = [
                        {
                            label: "Odmítnout",
                            onClick: () =>
                                setActiveForm( "requestContentForm", {
                                    formData: {status: "CLOSED"},
                                    primaryButtonLabel: "Odmítnout"
                                } )
                        },
                        {
                            label: "Vrátit",
                            onClick: () =>
                                setActiveForm( "requestContentForm", {
                                    formData: {pendingSide: "SENDER"},
                                    primaryButtonLabel: "Vrátit"
                                } )
                        }
                    ];
                }
            }
            else if( request.type === "GENERIC" )
            {
                buttons = [
                    {
                        label: "Uzavřít",
                        onClick: () =>
                            setActiveForm( "requestContentForm", {
                                formData: {status: "CLOSED"},
                                primaryButtonLabel: "Uzavřít"
                            } )
                    }
                ];
            }
            else
            {
                buttons = null;
            }
        }
        else if( onMySide )
        {
            buttons = [
                {
                    label: "Uzavřít",
                    onClick: () =>
                        setActiveForm( "requestContentForm", {
                            formData: {status: "CLOSED"},
                            primaryButtonLabel: "Uzavřít"
                        } )
                }
            ];
        }
        else
        {
            buttons = null;
        }
    }
    else if( request.status === "ACCEPTED" )
    {
        if( request.pendingSide === "RECIPIENT" )
        {
            if( onMySide )
            {
                buttons = [
                    {
                        label: "Vrátit",
                        onClick: () =>
                            setActiveForm( "requestContentForm", {
                                formData: {pendingSide: "SENDER"},
                                primaryButtonLabel: "Vrátit"
                            } )
                    },
                    {
                        label: "Zamítnout",
                        onClick: () =>
                            setActiveForm( "requestContentForm", {
                                formData: {status: "DISMISSED"},
                                primaryButtonLabel: "Zamítnout"
                            } )
                    }
                ];
            }
            else
            {
                buttons = null;
            }
        }
        else if( onMySide )
        {
            buttons = [
                {
                    label: "Vyřešeno",
                    onClick: () =>
                        setActiveForm( "requestContentForm", {
                            formData: {},
                            primaryButtonLabel: "Vyřešeno"
                        } )
                }
            ];
        }
        else
        {
            buttons = [
                {
                    label: "Zamítnout",
                    onClick: () =>
                        setActiveForm( "requestContentForm", {
                            formData: {status: "DISMISSED"},
                            primaryButtonLabel: "Zamítnout"
                        } )
                }
            ];
        }
    }
    else if( request.status === "RESOLVING" )
    {
        if( request.pendingSide === "RECIPIENT" )
        {
            if( onMySide )
            {
                if( request.type === "INVITE_PROVIDER" )
                {
                    buttons = [
                        {
                            label: "Odmítnout",
                            onClick: () =>
                                setActiveForm( "requestContentForm", {
                                    formData: {},
                                    primaryButtonLabel: "Odmítnout"
                                } )
                        },
                        {
                            label: "Navrhnout další",
                            onClick: () =>
                                setActiveForm( "requestContentForm", {
                                    formData: {},
                                    primaryButtonLabel: "Navrhnout další"
                                } )
                        }
                    ];
                }
                else
                {
                    buttons = [
                        {
                            label: "Zamítnout",
                            onClick: () =>
                                setActiveForm( "requestContentForm", {
                                    formData: {status: "DISMISSED"},
                                    primaryButtonLabel: "Zamítnout"
                                } )
                        }
                    ];
                }
            }
            else
            {
                buttons = null;
            }
        }
        else if( onMySide )
        {
            buttons = [
                {
                    label: "Nevyřešené",
                    onClick: () =>
                        setActiveForm( "requestContentForm", {
                            formData: {},
                            primaryButtonLabel: "Nevyřešené"
                        } )
                }
            ];
        }
        else
        {
            buttons = null;
        }
    }
    else if( request.status === "RESOLVED" )
    {
        if( request.type === "CREATE_PROVIDER" )
        {
            buttons = [
                {
                    label: "Nastavení organizace",
                    onClick: () =>
                        setActiveForm( "requestContentForm", {
                            formData: {},
                            primaryButtonLabel: "Nastavení organizace"
                        } )
                }
            ];
        }
        else if( request.type === "CREATE_PROJECT" )
        {
            buttons = null;
        }
        else if( request.type === "INVITE_PROVIDER" && request.pendingSide === "SENDER" && onMySide )
        {
            buttons = null;
        }
        else
        {
            buttons = null;
        }
    }
    else
    {
        buttons = null;
    }

    let primaryButtons = null;

    if( request.status === "INITIAL" )
    {
        if( request.pendingSide === "RECIPIENT" )
        {
            if( onMySide )
            {
                if( request.type === "INVITE_PROVIDER" )
                {
                    primaryButtons = [
                        {
                            label: "Přijmout",
                            onClick: () =>
                            {
                                // debugger;
                                setActiveForm( "requestContentForm", {
                                    formData: {
                                        status: "RESOLVING",
                                        pendingSide: "SENDER"
                                    },
                                    primaryButtonLabel: "Přijmout"
                                } );
                                getRequestById( match.params.id );
                            }
                        }
                    ];
                }
                else
                {
                    primaryButtons = [
                        {
                            label: "Přijmout",
                            onClick: () =>
                            {
                                // debugger;
                                setActiveForm( "requestContentForm", {
                                    formData: {status: "ACCEPTED"},
                                    primaryButtonLabel: "Přijmout"
                                } );
                                getRequestById( match.params.id );
                            }
                        }
                    ];
                }
            }
            else if( request.type === "GENERIC" )
            {
                primaryButtons = null;
            }
            else
            {
                primaryButtons = null;
            }
        }
        else
        {
            if( onMySide )
            {
                primaryButtons = [
                    {
                        label: "Znovu předat",
                        onClick: () =>
                        {
                            // debugger;
                            setActiveForm( "requestContentForm", {
                                formData: {},
                                primaryButtonLabel: "Znovu předat"
                            } );
                            getRequestById( match.params.id );
                        }
                    }
                ];
            }
            else
            {
                primaryButtons = null;
            }
        }
    }
    else if( request.status === "ACCEPTED" )
    {
        if( request.pendingSide === "RECIPIENT" )
        {
            if( onMySide )
            {
                primaryButtons = [
                    {
                        label: "Vyřešeno",
                        onClick: () =>
                        {
                            // debugger;
                            setActiveForm( "requestContentForm", {
                                formData: {
                                    status: "RESOLVING",
                                    pendingSide: "SENDER"
                                },
                                primaryButtonLabel: "Vyřešeno"
                            } );
                            getRequestById( match.params.id );
                        }
                    }
                ];
            }
            else
            {
                primaryButtons = null;
            }
        }
        else
        {
            if( onMySide )
            {
                primaryButtons = [{
                    label: "Znovu předat",
                    onClick: () =>
                    {
                        // debugger;
                        setActiveForm( "requestContentForm", {
                            formData: {},
                            primaryButtonLabel: "Znovu předat"
                        } );
                        getRequestById( match.params.id );
                    }
                }
                ];
            }
            else
            {
                primaryButtons = [
                    {
                        label: "Vyřešeno",
                        onClick: () =>
                        {
                            // debugger;
                            setActiveForm( "requestContentForm", {
                                formData: {},
                                primaryButtonLabel: "Vyřešeno"
                            } );
                            getRequestById( match.params.id );
                        }
                    }
                ];
            }
        }
    }
    else if( request.status === "RESOLVING" )
    {
        if( request.pendingSide === "RECIPIENT" )
        {
            if( onMySide )
            {
                if( request.type === "INVITE_PROVIDER" )
                {
                    primaryButtons = [
                        {
                            label: "Přijmout",
                            onClick: () =>
                                setActiveForm( "requestContentForm", {
                                    formData: {},
                                    primaryButtonLabel: "Přijmout"
                                } )
                        }
                    ];
                }
                else
                {
                    primaryButtons = [
                        {
                            label: "Vyřešeno",
                            onClick: () =>
                                setActiveForm( "requestContentForm", {
                                    formData: {},
                                    primaryButtonLabel: "Vyřešeno"
                                } )
                        }
                    ];
                }
            }
            else
            {
                primaryButtons = null;
            }
        }
        else
        {
            if( onMySide )
            {
                primaryButtons = [
                    {
                        label: "Vyřešeno",
                        onClick: () =>
                            setActiveForm( "requestContentForm", {
                                formData: {},
                                primaryButtonLabel: "Vyřešeno"
                            } )
                    }
                ];
            }
            else
            {
                primaryButtons = null;
            }
        }
    }
    else if( request.status === "RESOLVED" )
    {
        if( request.type === "CREATE_PROVIDER" )
        {
            primaryButtons = [
                {
                    label: "Stránka organizace",
                    onClick: () =>
                        setActiveForm( "requestContentForm", {
                            formData: {},
                            primaryButtonLabel: "Stránka organizace"
                        } )
                }
            ];
        }
        else if( request.type === "CREATE_PROJECT" )
        {
            primaryButtons = [
                {
                    label: "Detail projektu",
                    onClick: () =>
                        setActiveForm( "requestContentForm", {
                            formData: {},
                            primaryButtonLabel: "Detail projektu"
                        } )
                }
            ];
        }
        else if( request.type === "INVITE_PROVIDER" && request.pendingSide === "SENDER" && onMySide )
        {
            primaryButtons = [
                {
                    label: "Zobrazit dodavatele",
                    onClick: () =>
                        setActiveForm( "requestContentForm", {
                            formData: {},
                            primaryButtonLabel: "Zobrazit dodavatele"
                        } )
                }
            ];
        }
        else
        {
            primaryButtons = null;
        }
    }
    else
    {
        primaryButtons = null;
    }
    return {
        result: {headerTitle, buttons, primaryButtons},
        debugChosenCase,
        debug: {
            'request.status': request.status,
            'request.pendingSide': request.pendingSide,
            'request.type': request.type,
            'request.mySide': request.mySide,
            'onMySide': onMySide,
        }
    };
}



// WEBPACK FOOTER //
// ./src/pages/RequestDetail/RequestModel2017.js